// extracted by mini-css-extract-plugin
export default {"chat-message-media":"_media_widget-chat-message-media-4e8030","media-image-wrap":"_media_widget-media-image-wrap-b5959e","media-text":"_media_widget-media-text-034f17"};